/**
 * Darstellungs-Helfer der Admin-Umsatzseite, geteilt von Kacheln und Diagramm.
 *
 * Eigene Datei, weil react-refresh/only-export-components verlangt, dass
 * Komponenten-Module ausschliesslich Komponenten exportieren.
 */
import { activeBcp47 } from '../../lib/locale'

/**
 * Farben der Plattformen. hnt/iot/mobile sind mit
 * features/hotspots/HotspotRewardsChart abgestimmt, damit dieselbe Plattform in
 * der App ueberall dieselbe Farbe hat.
 */
const PROVIDER_COLORS: Record<string, string> = {
  hnt: '#22c55e',
  iot: '#06b6d4',
  mobile: '#a855f7',
  stripe: '#6366f1',
  apple: '#64748b',
  google: '#f59e0b',
}

/**
 * Das Backend haelt bewusst keine feste Provider-Liste, sondern gruppiert ueber
 * die echten Daten — ein kuenftiger Zahlungsweg taucht also ohne Code-Aenderung
 * auf und braucht eine Farbe, statt die Seite abstuerzen zu lassen.
 */
export function providerColor(provider: string): string {
  return PROVIDER_COLORS[provider] ?? '#94a3b8'
}

/**
 * Umsatzbetrag in USD. Bewusst NICHT lib/fmt.ts:fmtPrice — das schaltet
 * unterhalb von 0.01 auf fuenf Nachkommastellen (sinnvoll fuer Krypto-Token,
 * hier wuerde ein umsatzloser Tag aber als "0,00000 $" erscheinen). Umsatz ist
 * Fiat und hat immer zwei Nachkommastellen.
 */
export function fmtUsd(value: number): string {
  return new Intl.NumberFormat(activeBcp47(), {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(value)
}
